@if (!errorMessage) {
  <app-spinner />
} @else {
  <div class="alert alert-danger">
    {{errorMessage}}
  </div>
}
